import angular from 'angular';

import userAggregatedEventUrl from './user-aggregated-event.html';

export default function userAggregatedEvent($compile, $templateRequest) {
  'ngInject';

  return {
    restrict: 'E',
    scope: true,
    link($scope, $element, $attrs) {
      const isTooltip = $scope.$eval($attrs.isTooltip);
      $scope.hideThirdRow = $attrs.hideThirdRow ? $scope.$eval($attrs.hideThirdRow) : false;

      _init();

      async function _init() {
        const eventElement = angular.element(await $templateRequest(userAggregatedEventUrl));
        $scope.$evalAsync(() => {
          if (isTooltip) {
            eventElement.attr('uib-tooltip', $scope.$eval('event.displayLabel'));
            eventElement.attr('tooptip-placement', 'top');
          }

          $element.append(eventElement);
          $compile(eventElement)($scope);

          $scope.getDisplayMode = (mode, sort) =>
            mode === 'week' && sort === 'dtstart' ? 'month' : mode;
        });
      }
    },
  };
}
